import { render, staticRenderFns } from "./DepartmentType.vue?vue&type=template&id=42fd5f48&scoped=true"
import script from "./DepartmentType.vue?vue&type=script&lang=js"
export * from "./DepartmentType.vue?vue&type=script&lang=js"
import style0 from "./DepartmentType.vue?vue&type=style&index=0&id=42fd5f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd5f48",
  null
  
)

export default component.exports